import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconAiTutorBot = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 5308",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group 5309",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 34624200",
					d: "M3.33594 7.33594H2.66927C1.19651 7.33594 0.00260425 8.52985 0.00260425 10.0026C0.00260425 11.4754 1.19651 12.6693 2.66927 12.6693H3.33594V7.33594Z",
					fill: "#C0C0C0"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 34624201",
					d: "M12.6641 7.33594H13.3307C14.8035 7.33594 15.9974 8.52985 15.9974 10.0026C15.9974 11.4754 14.8035 12.6693 13.3307 12.6693H12.6641V7.33594Z",
					fill: "#C0C0C0"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 34624199",
					x: 2,
					y: 5.33594,
					width: 12,
					height: 10,
					rx: 5,
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					id: "Ellipse 56",
					cx: 8,
					cy: 2.66797,
					rx: 2,
					ry: 2,
					fill: "#FAFAFA"
				})
			]
		}), /* @__PURE__ */ _jsx("path", {
			id: "Union",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.66667 2.66797C8.66667 3.03616 8.36819 3.33464 8 3.33464C7.63181 3.33464 7.33333 3.03616 7.33333 2.66797C7.33333 2.29978 7.63181 2.0013 8 2.0013C8.36819 2.0013 8.66667 2.29978 8.66667 2.66797ZM8.66667 4.55416C9.44346 4.27961 10 3.53878 10 2.66797C10 1.5634 9.10457 0.667969 8 0.667969C6.89543 0.667969 6 1.5634 6 2.66797C6 3.53878 6.55654 4.27961 7.33333 4.55416V5.33464H6C4.51808 5.33464 3.22438 6.1405 2.53323 7.33792C2.35002 7.34694 2.17166 7.37446 2 7.41865C0.849849 7.71468 0 8.75874 0 10.0013C0 11.2439 0.849849 12.2879 2 12.584C2.07036 12.6021 2.14184 12.6174 2.21432 12.6298C2.7525 14.2033 4.24413 15.3346 6 15.3346H10C11.7559 15.3346 13.2475 14.2033 13.7857 12.6298C13.8582 12.6174 13.9296 12.6021 14 12.584C15.1502 12.2879 16 11.2439 16 10.0013C16 8.75874 15.1502 7.71468 14 7.41865C13.8283 7.37446 13.65 7.34694 13.4668 7.33792C12.7756 6.1405 11.4819 5.33464 10 5.33464H8.66667V4.55416ZM12.6667 9.33464C12.6667 7.86188 11.4728 6.66797 10 6.66797H6C4.52724 6.66797 3.33333 7.86188 3.33333 9.33463V11.3346C3.33333 12.8074 4.52724 14.0013 6 14.0013H10C11.4728 14.0013 12.6667 12.8074 12.6667 11.3346V9.33464ZM14 11.1563C14.3985 10.9257 14.6667 10.4948 14.6667 10.0013C14.6667 9.50778 14.3985 9.07688 14 8.84634V9.33464V11.1563ZM2 9.33463V11.1563C1.60147 10.9257 1.33333 10.4948 1.33333 10.0013C1.33333 9.50778 1.60147 9.07688 2 8.84634V9.33463ZM7.33333 9.33463C7.33333 8.96645 7.03486 8.66797 6.66667 8.66797C6.29848 8.66797 6 8.96645 6 9.33464V10.668C6 11.0362 6.29848 11.3346 6.66667 11.3346C7.03486 11.3346 7.33333 11.0362 7.33333 10.668V9.33463ZM9.33333 8.66797C9.70152 8.66797 10 8.96645 10 9.33463V10.668C10 11.0362 9.70152 11.3346 9.33333 11.3346C8.96514 11.3346 8.66667 11.0362 8.66667 10.668V9.33464C8.66667 8.96645 8.96514 8.66797 9.33333 8.66797Z",
			fill: "#959595"
		})]
	})
});
export default SvgIconAiTutorBot;
